import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import patrimoineImg from "../../images/©Antoine_Meyssonnier-4535.png";
const PatrinoimeHeroSection = () => {
  const path = useLocation();
  const [title, setTitle] = useState("L'histoire de l'eau ");
  const [desc, setDesc] = useState(
    "Depuis près de 4 milliards d’années, la même eau circule entre ciel et terre. Au cours de son parcours, elle se transforme et se retrouve dans l’air, dans les cours d’eau, sous terre, dans les glaciers et les océans. C’est le grand cycle ."
  );
  useEffect(() => {
    switch (path.search) {
      case "?histoire-de-leau":
        setTitle("L'histoire de l'eau ");
        setDesc("");
        break;
      case "?nos-equipements":
        setTitle("Nos Equipements");
        setDesc(
          "AQUAVESC, acteur majeur de la gestion de l'eau à Versailles, est responsable d’un patrimoine hydraulique exceptionnel, hérité du XVIIe siècle. Aqueducs, réservoirs et ouvrages historiques : Le syndicat veille à préserver ces équipements, témoins du passé, pour qu’ils  continuent de nourrir l’avenir de l’eau potable, entre hier, aujourd’hui et demain."
        );
        break;

      case "?source":
        setTitle("De la source au robinet");
        setDesc("");
        break;

      default:
        break;
    }
  }, [path.search]);

  return (
    <div className="">
      <section
        className="p-10 text-center lg:p-32 bg-black/70 bg-blend-overlay "
        style={{
          backgroundImage: `url(${patrimoineImg})`,
          backgroundSize: "cover",
        }}
      >
        <h1 className="text-2xl font-bold text-center text-white md:text-4xl lg:text-7xl">
          {title}
        </h1>

        <div className="flex justify-center mt-5">
          <p className="w-full text-white">{desc}</p>
        </div>
      </section>
    </div>
  );
};

export default PatrinoimeHeroSection;
